import { render } from "./Linkwebsite.vue?vue&type=template&id=45892f4c&scoped=true"
import script from "./Linkwebsite.vue?vue&type=script&lang=js"
export * from "./Linkwebsite.vue?vue&type=script&lang=js"

import "./Linkwebsite.vue?vue&type=style&index=0&id=45892f4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45892f4c"]])

export default __exports__